import { Navigation } from "./src/Navigation";

export default Navigation;